// React import not required with the JSX runtime
import { useAuth } from '@/core/auth/useAuth'
import { useSessionTimer } from '@/core/auth/useSessionTimer'
import { useInactivityTracker } from '@/core/auth/useInactivityTracker'
import AppRoutes from './router'

export default function App() {
  useAuth()
  useSessionTimer()
  useInactivityTracker()

  return <AppRoutes />
}

